// extracted by mini-css-extract-plugin
export default {"table":"CreateInterimCareSummarySupportProgress_table__O3ybW","appointment-item":"CreateInterimCareSummarySupportProgress_appointment-item__Ff7pE"};